import {
  OrientationType,
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";
import React, { FC, useCallback } from "react";
import { ReactComponent as Credit } from "../../../assets/icons/credit.svg";
import { ReactComponent as Debit } from "../../../assets/icons/debit.svg";
import { ReactComponent as Pix } from "../../../assets/icons/pix.svg";
import { ReactComponent as Wallet } from "../../../assets/icons/wallet.svg";
import { Kiosk, SystemType } from "../../../domains/kiosk/aggregates/Kiosk";
import { TransactionType } from "../../../domains/order/agreggates/payment/transactionType";
import ".././PaymentModal.css";
import "./SelectCardType.css";
import { useTranslation } from "i18n/useTranslation";
import { Trans } from "react-i18next";

interface SelectCardTypeProps {
  kiosk: Kiosk;
  total: number;
  onSelect: (value: TransactionType) => void;
  rechargePayment?: "Recharge" | "Payment" | "WalletRecharge";
  isProcessing?: boolean;
}
export const SelectCardType: FC<SelectCardTypeProps> = ({
  total,
  onSelect,
  kiosk,
  rechargePayment,
  isProcessing = false,
}) => {
  const { resolution, orientation } = useScreenStore();
  const { t } = useTranslation();

  const isSystemType = useCallback(
    (systemType: SystemType) => {
      return kiosk?.configSymstem?.find(
        (configSymstem) => configSymstem.systemType === systemType
      )
        ? true
        : false;
    },
    [kiosk]
  );

  const handleClick = useCallback(
    (type: TransactionType) => {
      if (!isProcessing) {
        onSelect(type);
      }
    },
    [isProcessing, onSelect]
  );

  return (
    <div className="selectCardType">
      <div
        className="text-selectCardType"
        style={{
          fontSize: resolution === ResolutionType.FULL_HD ? 40 : 28,
        }}
      >
        <Trans i18nKey="select_card_type.heading">
          Selecionar{" "}
          <b
            style={{
              fontSize: resolution === ResolutionType.FULL_HD ? 40 : 28,
            }}
          >
            forma de pagamento
          </b>
        </Trans>
      </div>
      <div
        className="buttonsContainer-selectCardType"
        style={{
          display: orientation === OrientationType.LANDSCAPE ? "grid" : "flex",
          gridTemplateColumns:
            orientation === OrientationType.LANDSCAPE ? "1fr 1fr" : undefined,
          gap: orientation === OrientationType.LANDSCAPE ? "15px" : "0",
        }}
      >
        {kiosk?.paymentCredit && (
          <div
            onClick={() => handleClick(TransactionType.credit)}
            className="button-selectCardType"
            style={{
              margin:
                orientation === OrientationType.LANDSCAPE ? "0" : "16px 0",
              minHeight: resolution === ResolutionType.FULL_HD ? 120 : 80,
              padding: resolution === ResolutionType.FULL_HD ? "28px" : "16px",
              opacity: isProcessing ? 0.5 : 1,
              pointerEvents: isProcessing ? "none" : "auto",
              cursor: isProcessing ? "not-allowed" : "pointer",
            }}
          >
            <Credit
              style={{
                height: resolution === ResolutionType.FULL_HD ? 95 : 65,
                width: resolution === ResolutionType.FULL_HD ? 95 : 65,
              }}
            />
            <div> {t("select_card_type.credit")}</div>
          </div>
        )}
        {kiosk?.paymentDebit && (
          <div
            onClick={() => handleClick(TransactionType.debit)}
            className="button-selectCardType"
            style={{
              margin:
                orientation === OrientationType.LANDSCAPE ? "0" : "16px 0",
              minHeight: resolution === ResolutionType.FULL_HD ? 120 : 80,
              padding: resolution === ResolutionType.FULL_HD ? "28px" : "16px",
              opacity: isProcessing ? 0.5 : 1,
              pointerEvents: isProcessing ? "none" : "auto",
              cursor: isProcessing ? "not-allowed" : "pointer",
            }}
          >
            <Debit
              style={{
                height: resolution === ResolutionType.FULL_HD ? 95 : 65,
                width: resolution === ResolutionType.FULL_HD ? 95 : 65,
              }}
            />
            <div> {t("select_card_type.debit")}</div>
          </div>
        )}
        {kiosk?.paymentVoucher && (
          <div
            onClick={() => handleClick(TransactionType.voucher)}
            className="button-selectCardType"
            style={{
              margin:
                orientation === OrientationType.LANDSCAPE ? "0" : "16px 0",
              minHeight: resolution === ResolutionType.FULL_HD ? 120 : 80,
              padding: resolution === ResolutionType.FULL_HD ? "28px" : "16px",
              opacity: isProcessing ? 0.5 : 1,
              pointerEvents: isProcessing ? "none" : "auto",
              cursor: isProcessing ? "not-allowed" : "pointer",
            }}
          >
            <Credit
              style={{
                height: resolution === ResolutionType.FULL_HD ? 95 : 65,
                width: resolution === ResolutionType.FULL_HD ? 95 : 65,
              }}
            />
            <div> {t("select_card_type.voucher")}</div>
          </div>
        )}
        {kiosk?.paymentPix && !(rechargePayment === "Payment") && (
          <div
            onClick={() => handleClick(TransactionType.pix)}
            className="button-selectCardType"
            style={{
              margin:
                orientation === OrientationType.LANDSCAPE ? "0" : "16px 0",
              minHeight: resolution === ResolutionType.FULL_HD ? 120 : 80,
              padding: resolution === ResolutionType.FULL_HD ? "28px" : "16px",
              opacity: isProcessing ? 0.5 : 1,
              pointerEvents: isProcessing ? "none" : "auto",
              cursor: isProcessing ? "not-allowed" : "pointer",
            }}
          >
            <Pix
              style={{
                height: resolution === ResolutionType.FULL_HD ? 95 : 65,
                width: resolution === ResolutionType.FULL_HD ? 95 : 65,
              }}
            />
            <div>Pix</div>
          </div>
        )}
        {kiosk?.paymentCashless /* && !isPreOrPos()*/ &&
          !rechargePayment &&
          (kiosk?.onlineCashlessControl ||
            isSystemType(SystemType.pospayOrderPad)) && (
            <div
              onClick={() => handleClick(TransactionType.cashless)}
              className="button-selectCardType"
              style={{
                margin:
                  orientation === OrientationType.LANDSCAPE ? "0" : "16px 0",
                minHeight: resolution === ResolutionType.FULL_HD ? 120 : 80,
                padding:
                  resolution === ResolutionType.FULL_HD ? "28px" : "16px",
                opacity: isProcessing ? 0.5 : 1,
                pointerEvents: isProcessing ? "none" : "auto",
                cursor: isProcessing ? "not-allowed" : "pointer",
              }}
            >
              <Credit
                style={{
                  height: resolution === ResolutionType.FULL_HD ? 95 : 65,
                  width: resolution === ResolutionType.FULL_HD ? 95 : 65,
                }}
              />
              <div> {t("select_card_type.cashless")}</div>
            </div>
          )}
        {kiosk?.paymentWallet && !(rechargePayment === "WalletRecharge") && (
          <div
            onClick={() => handleClick(TransactionType.wallet)}
            className="button-selectCardType"
            style={{
              margin:
                orientation === OrientationType.LANDSCAPE ? "0" : "16px 0",
              minHeight: resolution === ResolutionType.FULL_HD ? 120 : 80,
              padding: resolution === ResolutionType.FULL_HD ? "28px" : "16px",
              opacity: isProcessing ? 0.5 : 1,
              pointerEvents: isProcessing ? "none" : "auto",
              cursor: isProcessing ? "not-allowed" : "pointer",
            }}
          >
            <Wallet
              style={{
                height: resolution === ResolutionType.FULL_HD ? 95 : 65,
                width: resolution === ResolutionType.FULL_HD ? 95 : 65,
              }}
            />
            <div> Wallet</div>
          </div>
        )}
      </div>
      <div
        className="total-selectCardType"
        style={{
          fontSize: resolution === ResolutionType.FULL_HD ? 50 : 38,
        }}
      >
        <div>{t("select_card_type.total")}</div>
        <div>R$ {total.toFixed(2).replace(".", ",")}</div>
      </div>
    </div>
  );
};
